
import { Fragment, useState, useEffect } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Spinner,
} from "@material-tailwind/react";

import { useForm } from "react-hook-form";

import { useShared } from "../../hooks/useShared";
import UploadFiles from "../upload/UploadFiles";
import AIcon from "../partials/AIcon";
import APDate from "../fields/APDate";
import UploadImage from "../upload/UploadImage";

export default function UploadFileDialog({ v }) {
    const { http, com,
        openUploadFileDialog, setOpenUploadFileDialog, getLanguage } = useShared();
    const { register, control, formState: { errors }, setValue, getValues } = useForm({

    });
    const [files, setFiles] = useState([])
    const [loading, setLoading] = useState({ modelLoading: false, uploadLoading: false })
    const [dateRequired, setDateRequired] = useState(false)
    const [model, setModel] = useState(null)

    useEffect(() => {
        if (v?.modelID > 0) {
            setModel(null)
            setLoading(pre => ({ ...pre, modelLoading: true }))
            http.get(`/api/${v?.modelURL}/${v?.modelID}`).then(res => {
                console.log('UploadFileDialog: get model ', res);
                if (res.data.success) {
                    setModel(res.data.data)
                    setFiles(res.data?.data?.attachments || [])
                }
                setLoading(pre => ({ ...pre, modelLoading: false }))
            }, err => {
                console.log(err, 'err');
                setLoading(pre => ({ ...pre, modelLoading: false }))
            })
        }

    }, [v?.modelID, openUploadFileDialog])



    const closeDialog = (value) => {
        setOpenUploadFileDialog(false)
        setModel(null)
        return false
    };

    const uploadFiles = () => {
        const { aviza_date } = getValues()
        console.log(aviza_date, v?.attachName);

        if (v?.attachName === "Tariff" && (aviza_date === undefined && model?.aviza_date === null)) {
            setDateRequired(true)
            return;
        }

        else if (model?.id && files?.length > 0) {
            setLoading(pre => ({ ...pre, uploadLoading: true }))
            let formData = new FormData();
            formData.append('model', model?.model);
            formData.append('aviza_date', com.dateConvert(aviza_date));
            formData.append('TotalFiles', files?.length);
            files.map((f, i) => {
                formData.append('files' + i, f.file)
                if (f.id) formData.append('aId' + i, f.id);

            })

            http.upload(`api/uploadFiles`, formData).then(res => {
                console.log(res)
                if (res.data.success)
                    closeDialog()
                setLoading(pre => ({ ...pre, uploadLoading: false }))
                v?.refersh()
            }, err => {
                setLoading(pre => ({ ...pre, uploadLoading: false }))
            })

        } else {
            setDateRequired("Please upload a file")
        }
    }

    const uploadFileOrImage = ()=>{
        if(model?.id > 0){
           return v?.attachName === "Tariff"||v?.attachName === "Invoice"?
           <UploadImage v={{ files, setFiles, className: "" }} />:
           <UploadFiles v={{ files, setFiles, className: "" }} />
            
        }
        return null
    }

    const setAvizLabel = ()=>{
        return getLanguage()==='dr'?'تاريخ آويز':'Aviz Date'
    }

    return (
        <Fragment>

            {loading.modelLoading ? <Spinner color="teal" className="h-4 w-4" /> : 
            <Dialog open={openUploadFileDialog} className={`min-w-[90%] md:min-w-[40%] border-main-color absolute top-0  overflow-y-scroll ${v?.className} `} size="lg"
                animate={{
                    mount: { scale: 1, y: 0 },
                    unmount: { scale: 0.9, y: -100 },
                }}

                static
                onClose={() => null}
            >

                <DialogHeader className="bg-main-color py-1 px-2 text-blue-gray-100  text-base flex justify-between">
                    Upload file
                    <Button className="p-0 m-0 bg-transparent" onClick={closeDialog}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
                </DialogHeader>
                <DialogBody divider>
                    {v?.attachName === "Tariff" && <>
                        {model?.status !== 2 && <APDate v={{ register, errors, control, setValue, data: { label: setAvizLabel(), name: "aviza_date", type: 'date', isStyle: false, required: 'The aviza date is requieed', } }} />}
                        {dateRequired && <p className="text-red-900">The aviz date is requieed</p>}
                    </>
                    }
                  {uploadFileOrImage()}

                    {dateRequired && files?.length === 0 && <p className="text-red-900">Please upload a file</p>}
                </DialogBody>
                <DialogFooter>
                    <Button
                        variant="text"
                        color="red"
                        onClick={() => closeDialog(null)}
                        className="mr-1"
                    >
                        <span>Close</span>
                    </Button>
                    <Button

                        className="btn1 w-full md:w-[10%] " size='sm'
                        onClick={() => uploadFiles()}
                        disabled={loading.uploadLoading}>  {loading.uploadLoading ? <Spinner color="teal" className="h-4 w-4" /> : <span>Submit</span>}
                    </Button>
                </DialogFooter>
            </Dialog>}
        </Fragment>
    );
}
